import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CmsConfig, I18nModule, provideDefaultConfig} from '@spartacus/core';
import {DisableLoadingFormModule} from '../disable-loading-form/disable-loading-form.module';
import {DcpConfiguratorAddToCartButtonComponent} from './dcp-configurator-add-to-cart-button.component';

@NgModule({
  imports: [CommonModule, I18nModule, DisableLoadingFormModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ConfiguratorAddToCartButton: {
          component: DcpConfiguratorAddToCartButtonComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [DcpConfiguratorAddToCartButtonComponent],
  exports: [DcpConfiguratorAddToCartButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpConfiguratorAddToCartButtonModule {}
